import { render, staticRenderFns } from "./ActGrid.vue?vue&type=template&id=736c395a"
import script from "./ActGrid.vue?vue&type=script&lang=js"
export * from "./ActGrid.vue?vue&type=script&lang=js"
import style0 from "./ActGrid.vue?vue&type=style&index=0&id=736c395a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports